/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DatasetImportOperation } from '../types/dataset/DatasetImportOperation';
import { DatasetImportOperationStatus } from '../types/dataset/DatasetImportOperationStatus';
import { DatasetImportResult } from '../types/dataset-import/DatasetImportResult';

export const getDatasetImportOperationStatus = (datasetImportOperation: DatasetImportOperation) => {
  const { importStart, importFinish, result } = datasetImportOperation;
  let status: DatasetImportOperationStatus = DatasetImportOperationStatus.Failure;

  if (importStart === null && importFinish === null && result === null) {
    status = DatasetImportOperationStatus.Pending;
  } else if (importStart !== null && importFinish === null && result === null) {
    status = DatasetImportOperationStatus.Importing;
  } else if (result === DatasetImportResult.Successful) {
    status = DatasetImportOperationStatus.Successful;
  } else if (result === DatasetImportResult.Aborted) {
    status = DatasetImportOperationStatus.Aborted;
  }
  return status;
};
